const DeviceGroups = {
  1: "Alarm",
  2: "Immobilizer",
};
Object.freeze(DeviceGroups);

const DeviceGroupsByName = {
  Alarm: 1,
  Immobilizer: 2,
};
Object.freeze(DeviceGroupsByName);

function getDeviceGroupsString(t, id) {
  switch (id) {
    case 1:
      return t("Alarm");
    case 2:
      return t("Immobilizer");
    default:
      return "Unknown device group";
  }
}

export { DeviceGroupsByName, DeviceGroups, getDeviceGroupsString };
